import { Media } from '@app/shared/ui/atoms/Multimedia';
import { MediaData } from '@app/shared/types/player';

interface MediaListProps {
  data: MediaData[];
  currentIndex: number;
  onDataItemClick: (trackIndex: number) => void;
}

export const MediaList = ({ data, currentIndex, onDataItemClick }: MediaListProps) => {
  const filteredTracks = data.filter((_, index) => index !== currentIndex);

  return (
    <div className="max-h-[calc(6*40px)] overflow-y-auto scrollbar-hide rounded-2xl">
      <ul className="space-y-[6px]">
        {filteredTracks.map((dataItem, index) => (
          <Media
            key={dataItem.id}
            title={dataItem.title}
            type={dataItem.type}
            description={dataItem.description}
            onTrackClick={() => {
              onDataItemClick(index >= currentIndex ? index + 1 : index);
            }}
          />
        ))}
      </ul>
    </div>
  );
};
